import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { newRow, getFormattedDate } from "./constants";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import StatusCellComponent from 'views/pages/manage/masters/studentFinancials/paymentCollectionSetup/securityDepositSequencing/StatusCellComponent.jsx';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { getStatusStyles } from 'modules/studentTransfer/transferSetup/transferValidationConfig/constant.js'
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import { inputStyles, selectStyles } from "modules/studentRefund/thirdPartyBankAccMaster/constants";
import DayPickerV2 from "views/pages/manage/common/commonComponents/CustomDaysPicker/DayPicker";

const ListComponent = forwardRef(
    (
        {
            currentPage = 0,
            currPageSize,
            rowCount,
            nextButtonHandler,
            dropdown,
            setDropdownData,
            rows,
            createUpdateHandler,
            toggleStatusHandler,
            isBranchLevelConfig,
            isUpdatePermission,
            isDeletePermission,
            deleteConfigHandler
        },
        ref
    ) => {
        const [rowModesModel, setRowModesModel] = useState({});
        const [rowData, setRowData] = useState(rows);
        const [rowForm, setRowForm] = useState({});
        const [buLoading, setBuLoading] = useState(false);
        const [buAgainstBranchType, setBuAgainstBranchType] = useState([]);

        useEffect(() => setRowData(rows), [rows]);

        const rowFormHandler = (value, key) =>
            setRowForm((prev) => ({ ...prev, [key]: value }));

        const startEditing = (id, form) => {
            setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
            setRowForm(form);
        };


        const stopEditing = () => {
            const currForm = { ...rowForm };
            setRowModesModel((oldModel) => ({
                [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
            }));
            setRowForm({});
        };

        const handleEditClick = (params) => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                startEditing(params?.id, params?.row);
            }
        };

        const handleCancelClick = async (params) => {
            if (params?.row?.isNew) {
                setRowData(rows);
                setRowForm({});
            } else {
                stopEditing(params?.id);
            }
        };

        const handleSaveClick = async (params) => {
            createUpdateHandler(rowForm);
        };

        const addNewRow = async () => {
            if (!isObjEmpty(rowForm)) {
                failureToast(saveOrDeleteMsg);
            } else {
                let randomId = generateRandomId();
                let emptyRow = {
                    ...newRow,
                    isNew: true,
                    id: randomId
                };
                startEditing(randomId, emptyRow);
                setRowData((prev) => [emptyRow, ...prev]);
            }
        };

        useImperativeHandle(ref, () => ({
            addNewRow: addNewRow,
            startEditing: startEditing,
            stopEditing: stopEditing,
        }));


        const columns = [
            new AGridColDef("businessGrp", "Business Group*", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.businessGrp}
                            handleChange={(value) => rowFormHandler(value, "businessGrp")}
                            items={dropdown?.businessGrp}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),

            new AGridColDef("companyCode", "Company Code*", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.companyCode}
                            handleChange={(value) => rowFormHandler(value, "companyCode")}
                            items={dropdown?.companyCode}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            ...(isBranchLevelConfig ? [new AGridColDef("businessArea", "Business Area*", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.businessArea}
                            handleChange={(value) => rowFormHandler(value, "businessArea")}
                            items={dropdown?.businessArea}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                            isLoading={buLoading}
                        />
                    </div>)
                )] : []),
            new AGridColDef("career", "Career*", true)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.career}
                            handleChange={(value) => rowFormHandler(value, "career")}
                            items={dropdown?.career}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("term", "Term*", true)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.term}
                            handleChange={(value) => rowFormHandler(value, "term")}
                            items={dropdown?.term}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("programAction", "Program Action*", true)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AAutoComplete
                            currentValue={rowForm?.programAction}
                            handleChange={(value) => rowFormHandler(value, "programAction")}
                            items={dropdown?.programActions}
                            isMulti={false}
                            style={selectStyles}
                            autoFocus={params?.hasFocus}
                        />
                    </div>
                )),
            new AGridColDef("cycleName", "Cycle Name", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value} days</div>
                        </Tooltip></div> : <div>-</div>
                ))
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <AInput
                            value={rowForm?.cycleName}
                            handler={(val) => rowFormHandler(val, "cycleName")}
                            placeholder={"Cycle Name"}
                            disabled={false}
                            style={inputStyles}
                        />
                    </div>)),
            new AGridColDef("eligibleRange", "Elegible Date Range", false)
                .setMinWidth(220)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => {
                    const val = params?.value;
                    const display = val?.start
                        ? `${val.start}${val.end ? ` - ${val.end}` : ''}`
                        : '-';
                    return (
                        <div>
                            <Tooltip title={display}>
                                <div className={`ellipsis-text-container`}>{display}</div>
                            </Tooltip>
                        </div>
                    );
                })
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <DayPickerV2
                            mode="range"
                            value={rowForm?.eligibleRange}
                            onChange={(val) => rowFormHandler(val, "eligibleRange")}
                            placeholder="Select Range"
                        />
                    </div>
                )),
            new AGridColDef("triggerDays", "trigger Days", false)
                .setMinWidth(220)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => {
                    const val = params?.value;
                    const display = Array.isArray(val) && val.length > 0
                        ? val.join(', ')
                        : '-';
                    return (
                        <div>
                            <Tooltip title={display}>
                                <div className={`ellipsis-text-container`}>{display}</div>
                            </Tooltip>
                        </div>
                    );
                })
                .renderEditCellComponent((params) => (
                    <div style={editCellContainerStyle}>
                        <DayPickerV2
                            mode="multi"
                            value={rowForm?.triggerDays}
                            onChange={(val) => rowFormHandler(val, "triggerDays")}
                            placeholder="Select Days"
                        />
                    </div>
                )),
            new AGridColDef("createdOn", "Created On", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    const fomattedDate = `${moment(params?.value).format("YYYY-MM-DD HH:mm:ss")}`
                    return (
                        params?.value ? <div><Tooltip title={fomattedDate}>
                            <div className={`ellipsis-text-container`}>{fomattedDate}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("createdBy", "Created By", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("updatedOn", "Updated On", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("updatedBy", "Updated By", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("status", "Status", false)
                .setMinWidth(100)
                .setFlex(1)
                .editable(true)
                .renderCellComponent((params) => (
                    <CustomChip
                        text={params?.value}
                        textColor={getStatusStyles(params?.value)?.textColor}
                        bgColor={getStatusStyles(params?.value)?.bgColor}
                    />
                ))
                .renderEditCellComponent((params) => (<StatusCellComponent
                    params={params}
                    toggleStatusHandler={toggleStatusHandler}
                    rowForm={rowForm}
                    rowFormHandler={rowFormHandler}
                />
                ))
            ,
            new AGridColDef("actions", "Actions", false)
                .setMinWidth(130)
                .columnAlign("right")
                .setFlex(1)
                .renderCellComponent((params) => (
                    <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                        <ActionsCellComponent
                            mode={params.api.getRowMode(params?.id)}
                            params={params}
                            handleEditClick={handleEditClick}
                            handleCancelClick={handleCancelClick}
                            handleSaveClick={handleSaveClick}
                            rowForm={rowForm}
                            icon={true}
                            cancelIcon={<CancelIcon
                                className="mx-2 cursor"
                                onClick={() => handleCancelClick(params)}
                            />
                            }
                            editPermission={isUpdatePermission}
                            customEditIcon
                            handleDeleteClick={deleteConfigHandler}
                            deletePermission={isDeletePermission}
                            deleteIcon={true}

                        // isSaveDisabled={
                        //     !rowForm?.businessGroup ||
                        //     !rowForm?.companyCode ||
                        //     !rowForm?.branchType ||
                        //     (isBranchLevelConfig && !rowForm?.businessArea) ||
                        //     !rowForm?.academicCareer ||
                        //     !rowForm?.effectiveDate ||
                        //     !rowForm?.submissionDays ||
                        //     !rowForm?.approvalDays
                        // }
                        />
                    </div>

                )
                ),
        ];
        return (
            <div className="mt-3">
                <ADataGrid
                    removeWrapperContainer
                    rowModesModel={rowModesModel}
                    rows={rowData || []}
                    columns={columns}
                    rowId={(row) => row?.id}
                    rowHeight={50}
                    rowCount={rowCount}
                    loading={false}
                    currentPage={currentPage}
                    nextButtonHandler={nextButtonHandler}
                    sx={{
                        ...gridStyles,
                    }}
                    autoHeight
                    paginationModel={{ page: currentPage, pageSize: currPageSize }}
                />
            </div>
        );
    }
);
export default ListComponent;
